module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_j_melanistic.39c706ce.png";